import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { webApi } from 'src/app/api';
import { AppService } from 'src/app/app.service';
import { ActiveDeleteDialogComponent } from '../../special-offers/active-delete-dialog/active-delete-dialog.component';

export interface Help {
  _id: string;
  createdAt: Date;
  name: string;
  content: string;
  isActive: boolean;
}
@Component({
  selector: 'app-main-help',
  templateUrl: './main-help.component.html',
  styleUrls: ['./main-help.component.scss'],
})
export class MainHelpComponent implements OnInit {
  isAddEditCalled: boolean = false;
  dataToEdit: any;
  p: any = 1;
  count: any = 50;
  opened: boolean = false;
  modeNum: number = 0;
  positionNum: number = 0;
  dock: boolean = false;
  closeOnClickOutside: boolean = false;
  closeOnClickBackdrop: boolean = true;
  showBackdrop: boolean = false;
  animate: boolean = true;
  trapFocus: boolean = true;
  autoFocus: boolean = true;
  keyClose: boolean = false;
  toggleSortDiv: boolean = false;
  downloadReport: boolean = false;

  listOfHelpToDisplay: Array<Help> = [];
  listOfHelp: Array<Help> = [];
  listOfHelpOriginal: any = [];
  listOfProduct: any = [];
  listOfCategory: any = [];
  userDetails: any;
  isLoading: boolean = true;
  myHeaders = new Headers();

  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('TGV2WebAdminDetails')!);
    this.fetchHelpVideos();
  }

  constructor(
    private matDialog: MatDialog,
    public as: AppService,
    public routes: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) {}

  async fetchHelpVideos() {
    this.isLoading=true;
    this.listOfHelpToDisplay = [];
    try {
      let URL = '';
      const httpHeaders = new HttpHeaders({
        Authorization: `Bearer ${this.userDetails['accessToken']}`,
      });
      URL = `${webApi.domain + webApi.endPoint.fetchVideo}`;
      const param = {
        admin: true,
      };
      await this.as.fetchDetail(param, URL, httpHeaders).then((data: any) => {
        if (data['success']) {
          this.listOfHelpToDisplay = data['result'];
          this.listOfHelp = [...this.listOfHelpToDisplay];
          this.isLoading = false;
        } else {
          this.listOfHelpToDisplay = [];
          this.listOfHelp = [];
          this.isLoading = false;
        }
      });
    } catch (error) {
      this.listOfHelpToDisplay = [];
      this.listOfHelp = [];
      this.isLoading = false;
    }
  }

  addNewHelp() {
    this.toggleOpened();
  }

  deleteHelp(help: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { help: help, source: 'Delete Help' };

    let dialogRef = this.matDialog.open(
      ActiveDeleteDialogComponent,
      dialogConfig
    );
    dialogRef.updatePosition(dialogConfig.position);
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
      }
    });
    dialogRef.componentInstance.closeActivityAtDialog.subscribe(async (res) => {
      if (res == null) {
        return;
      } else {
        const param = {
          helpId: res['value']['_id'],
          action: 'Delete',
        };
        const httpHeaders = new HttpHeaders({
          Authorization: `Bearer ${this.userDetails['accessToken']}`,
        });
        const URL = `${
          webApi.domain + webApi.endPoint.updateActiveOrDeleteStatusVideo
        }`;
        await this.as
          .updateDataViaPut(param, URL, httpHeaders)
          .then((data: any) => {
            if (data['success']) {
              let index = 0;
              this.listOfHelpToDisplay.forEach((help: any, i: number) => {
                if (help['_id'] == res['value']['_id']) {
                  index = i;
                }
              });
              this.listOfHelpToDisplay.splice(index, 1);
              this.listOfHelp = [...this.listOfHelpToDisplay];

              this.showSuccessToaster('Help Deleted Successfully', 'Success');
            } else {
              this.showErrorToaster(
                'Error Occurred while deleting help. Try again',
                'Error'
              );
            }
          });
      }
    });
  }

  editHelp(help: any) {
    let helpToEdit;
    this.listOfHelpToDisplay.forEach((ofr: any) => {
      if (ofr['_id'] == help._id) {
        helpToEdit = ofr;
      }
    });
    this.dataToEdit = helpToEdit;
    this.toggleOpened();
  }

  updateActiveStatus(help: any, isActive: boolean) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { help: help, source: 'Active Help' };

    let dialogRef = this.matDialog.open(
      ActiveDeleteDialogComponent,
      dialogConfig
    );
    dialogRef.updatePosition(dialogConfig.position);
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
      }
    });
    dialogRef.componentInstance.closeActivityAtDialog.subscribe(async (res) => {
      if (res == null) {
        return;
      } else {
        const param = {
          helpId: res['value']['_id'],
          action: 'Status',
          isActive: isActive,
        };
        const httpHeaders = new HttpHeaders({
          Authorization: `Bearer ${this.userDetails['accessToken']}`,
        });
        const URL = `${
          webApi.domain + webApi.endPoint.updateActiveOrDeleteStatusVideo
        }`;
        await this.as
          .updateDataViaPut(param, URL, httpHeaders)
          .then((data: any) => {
            if (data['success']) {
              this.listOfHelpToDisplay.forEach((help: any, index: number) => {
                if (help['_id'] == res['value']['_id']) {
                  help.isActive = isActive;
                }
              });
              if (isActive) {
                this.showSuccessToaster(
                  'Help Activated Successfully',
                  'Success'
                );
              } else {
                this.showSuccessToaster(
                  'Help Inactivated Successfully',
                  'Success'
                );
              }
            } else {
              this.showErrorToaster(
                'Error Occurred while updating help. Try again',
                'Error'
              );
            }
          });
      }
    });
  }

  showSuccessToaster(message: string | undefined, title: string | undefined) {
    this.toastr.success(message, title);
  }
  showErrorToaster(message: string | undefined, title: string | undefined) {
    this.toastr.error(message, title);
  }

  toggleOpened(): void {
    this.isAddEditCalled = true;
    this.opened = !this.opened;
  }
  toggleClose(event: any): void {
    this.opened = !this.opened;
    this.isAddEditCalled = false;
    this.isLoading = true;
    if (event != null) {
      if (event == 'Error') {
        if (this.dataToEdit != null) {
          this.showErrorToaster(
            'Error while editing help details.Kindly try again',
            'Error'
          );
        } else {
          this.showErrorToaster(
            'Error while adding help details.Kindly try again',
            'Error'
          );
        }
        this.dataToEdit = null;
        this.isLoading = false;
        return;
      } else {
        const index = this.listOfHelpToDisplay.findIndex(
          (team: any) => team['_id'] == event['_id']
        );

        if (index == -1) {
          this.listOfHelpToDisplay.push(event);
          this.listOfHelp = [...this.listOfHelpToDisplay];
          this.showSuccessToaster('Help added successfully', 'Success');
        } else {
          this.listOfHelpToDisplay[index] = event;
          this.listOfHelp = [...this.listOfHelpToDisplay];
          this.showSuccessToaster('Help Updated successfully', 'Success');
        }
        this.dataToEdit = null;
        this.isLoading = false;
        return;
      }
    }

    this.dataToEdit = null;
    this.isLoading = false;
  }

  gotoBrandPage() {
    this.as.gotoComponent('Brand Management');
  }

  onBackdropClicked(): void {
    console.info('Backdrop clicked');
  }
}
